export const AUTH_REQUEST_ENDPOINTS = ['login', 'refresh', 'forgot'];
